import { register, CloudObject, File as OFile, defineProperty, defineRelation } from 'olympe';
import Observation from "./Observation";

/**
 * @extends {CloudObject}
 */
export default class Report extends CloudObject {

    /**
     * @return {string}
     */
    getVersion() {
        return this.get(Report.versionProp);
    }

    /**
     * @return {Date}
     */
    getCreationDate() {
        return this.get(Report.creationDateProp);
    }
}

// Hardcoded tags
register('01880faf63723b47005d', Report);
Report.versionProp = defineProperty('01880faf97e185078199');
Report.creationDateProp = defineProperty('01880fafb351e932cb66');
Report.documentRel = defineRelation('01880fb88e3247e69b87', Report, OFile);
Report.observationsRel = defineRelation('01880fb8e0feda88393e', Report, Observation);
